package features

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel

open class BaseViewModel {
    private val _scope = CoroutineScope(Dispatchers.Main + SupervisorJob())
    protected val viewModelScope: CoroutineScope get() = _scope

    fun onCleared() {
        _scope.cancel()
    }
}